import React from 'react';
import Svg from '../Svg';

const IconHeadphones02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 13C1 6.92487 5.92487 2 12 2C18.0751 2 23 6.92487 23 13V17C23 17.5523 22.5523 18 22 18C21.4477 18 21 17.5523 21 17V13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13V17C3 17.5523 2.55228 18 2 18C1.44772 18 1 17.5523 1 17V13ZM4 15.5C4 13.567 5.567 12 7.5 12C9.433 12 11 13.567 11 15.5V18.5C11 20.433 9.433 22 7.5 22C5.567 22 4 20.433 4 18.5V15.5ZM7.5 14C6.67157 14 6 14.6716 6 15.5V18.5C6 19.3284 6.67157 20 7.5 20C8.32843 20 9 19.3284 9 18.5V15.5C9 14.6716 8.32843 14 7.5 14ZM13 15.5C13 13.567 14.567 12 16.5 12C18.433 12 20 13.567 20 15.5V18.5C20 20.433 18.433 22 16.5 22C14.567 22 13 20.433 13 18.5V15.5ZM16.5 14C15.6716 14 15 14.6716 15 15.5V18.5C15 19.3284 15.6716 20 16.5 20C17.3284 20 18 19.3284 18 18.5V15.5C18 14.6716 17.3284 14 16.5 14Z"
    />
  </Svg>
);

export default IconHeadphones02;
